import { createLocalStorage } from '@/services/storage/storage-service';

export class PaymentStorage {
  constructor(storage = createLocalStorage()) {
    this.storage = storage;
  }

  get fpsSelectedBanks() {
    return this.storage.getItem('fps-selected-banks') || [];
  }

  set fpsSelectedBanks(value) {
    if (!value) return;
    this.storage.setItem('fps-selected-banks', [...new Set(value)].slice(0, 5));
  }

  addFpsSelectedBank(value) {
    if (!value) return;
    this.fpsSelectedBanks = [value, ...this.fpsSelectedBanks];
  }
}

export const createPaymentLocalStorage = () => new PaymentStorage();
